import { Songbook } from '@/core/db.ts';

const gradient: Record<Songbook['color'], string> = {
  default: 'bg-default-800 to-default',
  primary: 'bg-primary-800 to-primary',
  secondary: 'bg-secondary-800 to-secondary',
  success: 'bg-success-800 to-success',
  danger: 'bg-danger-800 to-danger',
  warning: 'bg-warning-800 to-warning',
};

export function createGradient(color: Songbook['color']) {
  return `bg-radial-[at_100%_120%] ${gradient[color]} from-transparent`;
}

export function songbookBg(songbook: Songbook) {
  switch (songbook.color) {
    case 'primary':
      return 'bg-primary-300';
    case 'secondary':
      return 'bg-secondary-300';
    case 'success':
      return 'bg-success-300';
    case 'danger':
      return 'bg-danger-300';
    case 'warning':
      return 'bg-warning-300';
    default:
    case 'default':
      return 'bg-default-300';
  }
}
